import requiredValidator from './validators/requiredValidator';
import typeValidator from './validators/typeValidator';
import maxLengthValidator from './validators/maxLengthValidator';
var validators = {
  requiredValidator: requiredValidator,
  typeValidator: typeValidator,
  maxLengthValidator: maxLengthValidator
};
var validatorNames = Object.keys(validators);

/**
 * Uses the registered validators to determine whether the specified field value is valid given its field config.
 *
 * @param fieldValue {String} The value of the field.
 * @param validationConfig {Object} An object that specifies the validations to apply to the field value.
 *          See validationConstants.js.
 * @returns {Object|null} null if the field value is valid, otherwise an object describing the validation failure.
 */
export default (function (fieldValue, validationConfig) {
  var errorObject = null;
  for (var _i = 0, _validatorNames = validatorNames; _i < _validatorNames.length; _i++) {
    var validatorName = _validatorNames[_i];
    var validator = validators[validatorName];

    // Perform the validation
    errorObject = validator(fieldValue, validationConfig);

    // Short circuit on error to prevent unneeded validation tests
    if (errorObject) break;
  }
  return errorObject;
});